function directive() {
    return {
        link: function ($scope, element) {
            $scope.$on('display-machine-icon', function (event, osicon) {

                var machIcon = d3.select(element[0]).append('svg')
                    .attr('x',0)
                    .attr('y',0)
                    .attr('width','40px')
                    .attr('height','30px')
                    .append('g').attr('transform', 'translate(0,8)scale(2)');

                // switch between text
                switch (osicon) {
                    case 'win':
                    machIcon.append('svg:path')
                        .attr('d', 'M6,0.6c1-0.4,3.1-1.2,5,0.4c-0.3,0.8-0.9,3.4-1.3,4.5c-1.6-1.2-3.8-0.9-5-0.3C5,4.2,6,0.6,6,0.6z')
                        .style('fill-rule', '#evenodd')
                        .style('clip-rule', '#evenodd')
                        .style('fill', '#D66C27');
                    machIcon.append('svg:path')
                        .attr('d', 'M4.5,5.9c1-0.4,3.1-1.2,5,0.4C9.3,7,8.6,9.6,8.2,10.7c-1.6-1.2-3.8-0.9-5-0.2C3.5,9.4,4.5,5.9,4.5,5.9z')
                        .style('fill-rule', '#evenodd')
                        .style('clip-rule', '#evenodd')
                        .style('fill', '#0390C8');
                    machIcon.append('svg:path')
                        .attr('d', 'M15.3,6.3c-1,0.4-3.1,1.2-5-0.4c0.3-0.8,0.9-3.4,1.3-4.5c1.6,1.2,3.8,0.9,5,0.2C16.3,2.7,15.3,6.3,15.3,6.3z')
                        .style('fill-rule', '#evenodd')
                        .style('clip-rule', '#evenodd')
                        .style('fill', '#87B340');
                    machIcon.append('svg:path')
                        .attr('d', 'M13.9,11.4c-1,0.4-3.1,1.2-5-0.4c0.3-0.8,0.9-3.4,1.3-4.5c1.6,1.2,3.8,0.9,5,0.3C14.9,7.9,13.9,11.4,13.9,11.4z')
                        .style('fill-rule', '#evenodd')
                        .style('clip-rule', '#evenodd')
                        .style('fill', '#FCCE32');
                    return;
                case 'os':
                    machIcon.append('svg:path')
                        .attr('d', 'M11.7,1.9c0.4-0.5,0.7-1.2,0.6-1.9c-0.7,0-1.4,0.5-1.9,1C10,1.5,9.7,2.2,9.8,2.9C10.5,2.9,11.3,2.5,11.7,1.9z')
                        .style('fill-rule', '#evenodd')
                        .style('clip-rule', '#evenodd')
                        .style('fill', '#818385');
                    machIcon.append('svg:path')
                        .attr('d', 'M13.7,5.4c0.2-0.6,0.6-1.1,1.2-1.4c-0.6-0.8-1.5-1.2-2.4-1.2c-1.1,0-1.6,0.5-2.3,0.5c-0.8,0-1.4-0.5-2.4-0.5c-0.9,0-1.9,0.6-2.6,1.5C5,4.7,4.9,5.1,4.8,5.6C4.6,7,4.9,8.8,6,10.4C6.5,11.1,7.2,12,8.1,12c0.8,0,1-0.5,2.1-0.5c1.1,0,1.3,0.5,2.1,0.5c0.9,0,1.6-1,2.2-1.7c0.4-0.6,0.5-0.8,0.8-1.5C13.8,8.3,13.2,6.7,13.7,5.4z')
                        .style('fill-rule', '#evenodd')
                        .style('clip-rule', '#evenodd')
                        .style('fill', '#818385');
                    return;
                case 'linux':
                    machIcon.append('svg:path')
                        .attr('d', 'M10.4,0c0.5,0,1.3,0.4,1.4,1c0.1,0.3,0,0.7,0,1.1c0,0.4,0,0.8,0,1.2c0.1,0.7,0.6,1.1,0.9,1.7c0.2,0.3,0.3,0.6,0.4,0.9c0.1,0.4,0.2,0.7,0.2,1.1c0.1,0.4,0.1,0.7,0.1,1.1c0,0.2,0,0.3,0,0.5c0,0.2-0.1,0.3-0.1,0.5c0,0.2,0,0.3,0.2,0.3c0.2,0,0.3,0,0.5,0c0.3,0,0.7,0.2,0.6,0.5c-0.4,0.5-0.8,1.2-1.3,1.6c-0.2,0.2-0.4,0.5-0.7,0.5c-0.3,0.1-0.7,0.1-0.9-0.1c-0.1-0.1-0.2-0.2-0.2-0.3c0-0.1-0.1-0.1-0.1-0.2c0-0.1,0-0.1-0.1-0.1c-0.4,0-0.8,0-1.2,0c-0.4,0-0.7-0.1-1.1-0.2c-0.1-0.1-0.3-0.1-0.4-0.2c-0.1-0.1-0.2,0.3-0.3,0.3c-0.1,0.2-0.3,0.5-0.6,0.5c-0.1,0-0.3,0-0.4,0c-0.2-0.1-0.3-0.2-0.5-0.3c-0.3-0.2-0.6-0.4-0.9-0.6c-0.3-0.2-0.7-0.5-0.7-0.8c0.1-0.3,0.2-0.4,0.5-0.4c0.1,0,0.3,0,0.3-0.1c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2,0-0.3c0.1-0.3,0.5-0.1,0.7,0c0.1-0.1,0.2-0.2,0.2-0.3C7,8.4,7.1,8.4,7.1,8.2C6.9,6.7,7.8,5.3,8.5,4c0.1-0.2,0.2-0.4,0.3-0.6c0.1-0.1,0.1-0.4,0.1-0.6c0-0.5,0-1,0-1.4c0-0.4,0.1-0.7,0.4-1C9.6,0.2,10,0,10.4,0z')
                        .style('fill-rule', '#evenodd')
                        .style('clip-rule', '#evenodd')
                        .style('fill', '#231F20');
                    machIcon.append('svg:path')
                        .attr('d', 'M11,3.4c0.1,0.2,0.1,0.5,0.2,0.7c0.1,0.2,0.2,0.4,0.3,0.7c0.2,0.5,0.5,0.9,0.6,1.4c0.2,0.5,0.3,0.9,0.2,1.4c-0.1,0.2-0.1,0.5-0.2,0.7c0,0.1-0.1,0.1-0.1,0.1c-0.1,0.1-0.1,0.2-0.1,0.4c-0.2,0-0.3-0.2-0.5-0.1c-0.2,0-0.2,0.4-0.2,0.5c0,0.3,0,0.5,0,0.8c0,0.1,0,0.1,0,0.2c-0.1,0-0.1,0.1-0.2,0.1c-0.1,0-0.2,0.1-0.3,0.1c-0.5,0.1-1,0.1-1.5,0c-0.1,0-0.2-0.1-0.3-0.1c-0.2-0.1-0.2-0.1-0.2-0.2c0-0.2-0.2-0.6-0.3-0.8c-0.2-0.5-0.4-1-0.6-1.6c0-0.1-0.1-0.2-0.1-0.3c0-0.1,0-0.2,0-0.3c0.1-0.3,0.2-0.5,0.3-0.8C8,6,8.2,5.8,8.3,5.6c0.1-0.2,0.1-0.5,0.2-0.7c0.1-0.2,0.2-0.4,0.3-0.7C9,4,9.1,3.7,9.2,3.5c0.3,0.3,0.5,0.3,0.9,0.3c0.2,0,0.3-0.1,0.5-0.1C10.6,3.6,10.9,3.4,11,3.4z')
                        .style('fill-rule', '#evenodd')
                        .style('clip-rule', '#evenodd')
                        .style('fill', '#FFFFFF');
                    machIcon.append('svg:path')
                        .attr('d', 'M8.9,1.2C8.9,1.2,8.9,1.2,8.9,1.2C8.9,1.2,8.9,1.2,8.9,1.2z')
                        .style('fill-rule', '#evenodd')
                        .style('clip-rule', '#evenodd')
                        .style('fill', '#C5C7C9');
                    machIcon.append('svg:path')
                        .attr('d', 'M8.9,1.8C8.9,1.8,8.9,1.7,8.9,1.8C8.9,1.7,8.9,1.8,8.9,1.8z')
                        .style('fill-rule', '#evenodd')
                        .style('clip-rule', '#evenodd')
                        .style('fill', '#C5C7C9');
                    machIcon.append('svg:path')
                        .attr('d', 'M8.9,3.4C8.9,3.4,8.9,3.4,8.9,3.4C8.9,3.4,8.9,3.4,8.9,3.4z')
                        .style('fill-rule', '#evenodd')
                        .style('clip-rule', '#evenodd')
                        .style('fill', '#C5C7C9');
                    machIcon.append('svg:path')
                        .attr('d', 'M7.3,8.5c0.1,0.1,0.2,0.3,0.3,0.4c0.1,0.2,0.2,0.5,0.2,0.7C7.9,9.9,8,10.4,8,10.8c0,0.4-0.3,0.6-0.6,0.6c-0.2,0-0.4-0.1-0.6-0.2c-0.2-0.1-0.4-0.2-0.6-0.4c-0.3-0.2-0.8-0.5-0.9-0.9C5.2,9.8,5.4,9.6,5.6,9.6c0.2,0,0.3,0,0.4-0.2c0.1-0.1,0-0.3,0-0.4c0.1-0.2,0.3-0.1,0.5,0c0.1,0,0.1,0.1,0.2,0c0.1-0.1,0.1-0.2,0.2-0.3C7,8.6,7.3,8.3,7.3,8.5z')
                        .style('fill-rule', '#evenodd')
                        .style('clip-rule', '#evenodd')
                        .style('fill', '#F5C055');
                    machIcon.append('svg:path')
                        .attr('d', 'M11.8,8.8c0.1,0,0.1,0.1,0.2,0.1c0,0.1,0,0.2,0,0.3c0,0.2,0.3,0.3,0.5,0.4C12.9,9.7,13,9.3,13.2,9c0.1,0,0.1,0.3,0.1,0.4c0.1,0.2,0.3,0.1,0.4,0.1c0.3-0.1,0.9,0,0.7,0.5c-0.2,0.3-0.5,0.6-0.7,0.9c-0.1,0.1-0.2,0.3-0.4,0.4c-0.1,0.1-0.3,0.2-0.4,0.3c-0.3,0.2-0.6,0.4-1,0.3c-0.5-0.1-0.5-0.6-0.6-1c-0.1-0.4-0.1-0.9-0.1-1.3c0-0.2,0-0.4,0.1-0.6C11.4,8.8,11.6,8.7,11.8,8.8z')
                        .style('fill-rule', '#evenodd')
                        .style('clip-rule', '#evenodd')
                        .style('fill', '#F5C055');
                    machIcon.append('svg:ellipse')
                        .attr('cx', '10.9')
                        .attr('cy', '2.1')
                        .attr('rx', '0.4')
                        .attr('ry', '0.6')
                        .style('fill-rule', '#evenodd')
                        .style('clip-rule', '#evenodd')
                        .style('fill', '#FFFFFF');
                    machIcon.append('svg:ellipse')
                        .attr('cx', '9.3')
                        .attr('cy', '2.1')
                        .attr('rx', '0.4')
                        .attr('ry', '0.6')
                        .style('fill-rule', '#evenodd')
                        .style('clip-rule', '#evenodd')
                        .style('fill', '#FFFFFF');
                    machIcon.append('svg:path')
                        .attr('d', 'M10.1,2.5c0.2,0,0.3,0.2,0.4,0.2c0.2,0.1,0.4,0,0.4,0.2c0.1,0.2-0.1,0.3-0.3,0.4c-0.2,0.1-0.3,0.2-0.6,0.2s-0.4,0-0.6-0.1C9.4,3.3,9.3,3.2,9.3,3c0-0.2,0.2-0.2,0.4-0.3C9.7,2.7,9.9,2.4,10.1,2.5z')
                        .style('fill-rule', '#evenodd')
                        .style('clip-rule', '#evenodd')
                        .style('fill', '#F5C055');
                    return;
                default:
                    return;
                }
            });
            $scope.$on('$destroy', function () {
                element.remove();
            });
        }
    };
}

directive.$inject = [];
module.exports = directive;


/** WEBPACK FOOTER **
 ** ./src/pages/directives/machicon/machicon.js
 **/